import { publicApiBase } from './api.js';

// Akun penonton halaman Anime publik (opsional, login Discord): hanya untuk
// anime favorit. Sesi berupa cookie HttpOnly dari bot (lihat
// discord-bot/anime-users.js), jadi tidak ada token yang disimpan di sini.

const EMPTY = { enabled: false, canLogin: false, user: null, favorites: [] };

export async function fetchAnimeAccount() {
    try {
        const response = await fetch(`${publicApiBase()}/akun`, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return EMPTY;
        const data = await response.json();
        // Login hanya dari alamat publik: cookie & redirect Discord terikat ke alamat itu.
        return { ...EMPTY, ...data, canLogin: Boolean(data.enabled && data.loginOrigin === window.location.origin) };
    } catch {
        return EMPTY;
    }
}

export function animeLoginUrl() {
    const params = new URLSearchParams(window.location.search);
    params.delete('login');
    const qs = params.toString();
    return `/a/akun/masuk?next=${encodeURIComponent(`${window.location.pathname}${qs ? `?${qs}` : ''}`)}`;
}

async function post(path, json = {}) {
    const response = await fetch(`${publicApiBase()}/akun${path}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(json),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || `Gagal (${response.status})`);
    return data;
}

export async function setAnimeFavorite(seriesId, on) {
    return (await post('/favorit', { seriesId, on })).favorites || [];
}

export function animeLogout() {
    return post('/keluar');
}

export function deleteAnimeAccount() {
    return post('/hapus');
}
